// @ts-nocheck


import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { DatePicker, RangePicker } from '../../../components/ant/DatePicker';


import { formatDateTimeToISOString } from '../../../lib/helpers';

import {
  Filter,
  FilterContainer,
  FilterItem,
  Selects,
  FilterButtonsContainer } from
'../../../components';

import Field from '../../../components/card/Field';

const { VehicleSelect } = Selects;

const SpoilerContent = styled.div.withConfig({ displayName: "Filter__SpoilerContent", componentId: "sc-lcf03u-0" })(["padding:16px;"]);


















export const MeasuringDeviceCertificationsFilter = ({
  style,
  filter,
  cleanFilter,
  applyFilter
}) =>
<SpoilerContent style={{ ...style }}>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}
      additionalFilter={true}>

        {({
        values,
        changeValue,
        applyFilter,
        showAdditional,
        handleAdditional,
        cleanFilter
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <VehicleSelect
              size="small"
              value={values.vehicleId}
              optionTitle={(vehicle) => vehicle.licensePlate}
              onChange={(value) => changeValue('vehicleId', value)} />

              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <RangePicker
              format="DD.MM.YYYY"
              size="small"
              placeholder={['Начало', 'Конец']}
              value={[
              values.startDate ? moment.utc(values.startDate) : null,
              values.endDate ? moment.utc(values.endDate) : null]
              }
              onChange={(value, dateString) => {
                const [startDate, endDate] = value;
                const [startDateString, endDateString] = dateString;
                changeValue(
                  'startDate',
                  formatDateTimeToISOString(startDate, startDateString)
                );
                changeValue(
                  'endDate',
                  formatDateTimeToISOString(endDate, endDateString)
                );
              }} />

              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <DatePicker
              size="small"
              format="DD.MM.YYYY"
              value={
              values.maintenanceDate && moment.utc(values.maintenanceDate)
              }
              placeholder="Дата сертификации"
              onChange={(value, dateString) =>
              changeValue(
                'maintenanceDate',
                formatDateTimeToISOString(value, dateString)
              )
              } />

              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <DatePicker
              size="small"
              format="DD.MM.YYYY"
              value={values.nextActDate && moment.utc(values.nextActDate)}
              placeholder="Следующая дата серт."
              onChange={(value, dateString) =>
              changeValue(
                'nextActDate',
                formatDateTimeToISOString(value, dateString)
              )
              } />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter}
          handleAdditional={handleAdditional}
          showAdditional={showAdditional} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;


export default MeasuringDeviceCertificationsFilter;
